import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Card, Btn } from "@/components/common";
import { Sparkles, TrendingUp, TrendingDown, Minus } from "lucide-react";

const ICON = { alza: <TrendingUp size={14} className="text-emerald-600" />, abbassa: <TrendingDown size={14} className="text-rose-600" />, mantieni: <Minus size={14} className="text-slate-400" /> };

export default function AiPricing() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/quotes-ai-last").then((r) => setD(r.data?.sintesi ? r.data : null)); }, []);
  const run = async () => {
    setBusy(true);
    try { setD((await api.post("/quotes/ai-suggest")).data); } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <Card className="p-4" data-testid="quote-ai">
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <Sparkles size={16} className="text-violet-600" />
        <span className="text-sm font-semibold">Suggerimenti AI sui prezzi</span>
        <span className="text-[11px] text-slate-400">guarda occupazione confermata, costi dei prossimi mesi ed esito dei preventivi</span>
        <Btn data-testid="quote-ai-run" onClick={run} disabled={busy} className="ml-auto">{busy ? "Analisi in corso…" : "Chiedi all'AI"}</Btn>
      </div>
      {!d && !busy && <div className="text-sm text-slate-400 py-4" data-testid="quote-ai-empty">Nessuna analisi ancora: premi "Chiedi all'AI".</div>}
      {d && (
        <div data-testid="quote-ai-result">
          <p className="text-sm text-slate-700 mb-2">{d.sintesi}</p>
          <ul className="divide-y divide-slate-100">
            {(d.suggerimenti || []).map((s, i) => (
              <li key={i} className="py-2 flex gap-2 text-sm" data-testid={`quote-ai-sugg-${i}`}>
                {ICON[s.azione] || ICON.mantieni}
                <div><b>{s.voce}</b> <span className="text-xs font-semibold text-slate-500">{s.azione} {s.variazione_pct ? `${s.variazione_pct > 0 ? "+" : ""}${s.variazione_pct}%` : ""}</span><div className="text-xs text-slate-500">{s.motivo}</div></div>
              </li>
            ))}
          </ul>
          <p className="text-[11px] text-slate-400 mt-2">Analisi del {d.created_at?.slice(0, 10)} sul {d.listino}. Sono consigli: i prezzi cambiano solo se li modifichi tu nelle impostazioni.</p>
        </div>
      )}
    </Card>
  );
}
